import { FlexRow } from '@editor/components/utilities/layouts';
import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const AppliedPromoCodeWrapper = styled(FlexRow)`
  align-items: center;
  gap: 8px;

  height: 30px;
  width: fit-content;
  max-width: 240px;

  box-sizing: border-box;

  padding: 7px 14px;

  background: ${themeStyle.varBackgroundAlt};

  border-radius: ${themeStyle.radiusMedium};

  text-transform: uppercase;
`;

export const AppliedPromoCode = styled(H6)`
  max-width: 100%;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Clickable = styled.button<{ disabled?: boolean }>`
  all: unset;

  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
`;
